/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Train_LeadInputs */

const en_how_page_train_lead = /** @type {(inputs: How_Page_Train_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every set in one tap.`)
};

const pl_how_page_train_lead = /** @type {(inputs: How_Page_Train_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda seria jednym dotknięciem.`)
};

/**
* | output |
* | --- |
* | "Every set in one tap." |
*
* @param {How_Page_Train_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_train_lead = /** @type {((inputs?: How_Page_Train_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Train_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_train_lead(inputs)
	return en_how_page_train_lead(inputs)
});